export default "__VITE_ASSET__DEWDCqjJ__"